/* unplugin-vue-components disabled */import { render } from "./yuji.vue?vue&type=template&id=7c880099&scoped=true"
import script from "./yuji.vue?vue&type=script&lang=js"
export * from "./yuji.vue?vue&type=script&lang=js"

import "./yuji.vue?vue&type=style&index=0&id=7c880099&lang=scss&scoped=true"
import "./yuji.vue?vue&type=style&index=1&id=7c880099&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c880099"]])

export default __exports__